import SmartCreate from './SmartCreate'

export default SmartCreate
// eslint-disable-next-line import/export
export * from './SmartCreate'
